import { useMemo } from 'react'
import { usePaletteTheme } from '../../../context/paletteTheme'
import { Bubble } from 'react-chartjs-2'
import { Chart as ChartJS, LinearScale, PointElement, Tooltip, Legend} from 'chart.js'
import { NoGraph } from './utils'
import ChartDataLabels from 'chartjs-plugin-datalabels'

ChartJS.register(LinearScale, PointElement, Tooltip, Legend, ChartDataLabels)

const bubbleOptions = (colors, title) => ({
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
        legend: {
        display: false
        },
        tooltip: {
        backgroundColor: colors.dark1,
        bodyColor: colors.textPrimary,
        borderColor: colors.divider,
        borderWidth:1,
        callbacks: {
            label: (context) => {
            return context.raw.tooltip
            }
        }
        },
    },
    scales: {
        x: {
        beginAtZero: true,
        grid: {
            drawBorder: false,
            display: true,
            color: (context) => (context.tick.value === 0 ? colors.dark5 : 'transparent')
        },
        ticks: {
            display: false,
        },
        title: {
            display: true,
            text: [title.x, `*Size= ${title.r}`],
            color: colors.textPrimary,
            align: 'start'
        }
        },
        y: {
        beginAtZero: true,
        grid: {
            drawBorder: false,
            display: true,
            color: (context) => (context.tick.value === 0 ?  colors.dark5 : 'transparent')
        },
        ticks: {
            display: false,
        },
        title: {
            display: true,
            text: title.y,
            color: colors.textPrimary,
            align: 'start'
        }
        },
    }
})

const ReportBubbleGraph = ({data, title}) => {
    const { colors } = usePaletteTheme()

    const options = useMemo(() => bubbleOptions(colors, title), [colors, title])

    return ( data?.datasets?.length ? <Bubble data={data} options={options} height={400}/> : <NoGraph /> )
}

export default ReportBubbleGraph